export const patientLookupES = {
    "Breast and Ovarian Cancer Screening Questionnaire": "Breast and Ovarian Cancer Screening Questionnaire",
    "Patient Lookup": "Búsqueda de pacientes",
    "Enter Your": "Ingrese su",
    "Search": "Buscar",
    "No results found": "No hay resultados",
    "No results found message": "No hay resultados. Por favor, notifique al personal",
    "Close": "Cerrar",
    "selectStepInstructions": "Por favor seleccione las tres primeras letras de su nombre y  las tres primeras letras de su apellido. Si usted no ve su nombre en la lista, notifique a nuestro personal.",
    "Back": "Anterior",
    "Confirm": "Confirmar",
    "First Name": "Nombre",
    "Last Name": "Apellido",
    "Incorrect Date of Birth": "Fecha de Nacimiento Incorrecta. Por favor, inténtelo de nuevo, o notifique al personal.",
    "Please Enter Your": "Por favor ingrese su",
    "Cancel": "Cancelar",
    "dob_validation_failed": "Fecha de Nacimiento Incorrecta",
    "dob_validation_failed_msg": "Fecha de Nacimiento Incorrecta. Por favor, inténtelo de nuevo, o notifique al personal.",
    "Clear": "Clear",
    "Confirmation Message": "Mensaje de confirmación",
    "MRN not found": "no ha sido encontrado. Favor de comprobar que lo entró correcto.",
    "Unable to create new pedigree": "Unable to create new pedigree",
    "Unable to create new pedigree message": "Unable to create new pedigree. Please notify the staff",
    "Values dont match": "Values don't match",
    "Entered": "Entered",
    "is not matching firstly entered": "is not matching firstly entered",
    "session_timeout": "Session Timeout",
    "session_timeout_msg": "Your session has expired. Press a button to reload the page.",
    "reload": "Reload",
    "Not Available": "Not Available"
};